import SchoolIcon from "@mui/icons-material/School";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import StyledListItemIcon from "src/components/List/StyledListItemIcon";

import CourseAction from "./CourseAction";
import { highlightText } from "./utils";
import type { CourseTreeItemProps } from "./types";
import type { CourseTreeActionCourse } from "./types";

const getNumericId = (value: number | string | undefined): number => Number(value);

const CourseTreeItem = ({ nodeId, course, customCourse = null, group = null, searchTerm }: CourseTreeItemProps) => {
  const obj = course || customCourse || group;
  if (!obj) return null;

  const id = customCourse ? `cc_${customCourse.id}` : group ? `g_${group.groupId}` : course?.id;
  const title = `(${id}) ${obj.shortname || obj.fullname || obj.name}`;
  const key = `${nodeId}/c${id}`;

  return (
    <ListItem key={key}>
      <StyledListItemIcon>
        <SchoolIcon />
      </StyledListItemIcon>
      <ListItemText>
        <Box
          sx={{
            display: "flex",
            lineHeight: 2,
          }}
        >
          {obj.hidden ? (
            <Box
              sx={{
                color: "text.disabled",
                fontStyle: "italic",
              }}
            >
              <span>{highlightText(title, searchTerm)}</span>
            </Box>
          ) : (
            <span>{highlightText(title, searchTerm)}</span>
          )}
          <CourseAction
            course={
              {
                ...obj,
                id: getNumericId(obj.id),
                groupId: group?.groupId ? getNumericId(group.groupId) : undefined,
                isCustom: Boolean(customCourse),
              } as CourseTreeActionCourse
            }
          />
        </Box>
      </ListItemText>
    </ListItem>
  );
};

export default CourseTreeItem;
